// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1Z6Cv","header":"PatientBlock_header__2KI2Z","label":"PatientBlock_label__1OY_a","option":"PatientBlock_option__3DTJ3"};